import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../../../context/ProductBuilder/machine';
import { getCurrentVariant } from '../../../../../helpers/getCurrentVariant';
import {
  getCurtainRailHexColour,
  getRollerHexColour,
} from '../../../../../helpers/getHexColorCode';
import { getPatternImages } from '../../../../../helpers/getPatternImages';

export const FasciaRollerBlind = React.forwardRef(
  (
    props: React.SVGProps<SVGSVGElement>,
    setProductImageRef: React.Ref<SVGSVGElement>,
  ) => {
    const [state] = useService(productBuilderMachine);
    const patternUrl = getPatternImages(state);
    const currentVariant = getCurrentVariant(state.context);

    const currentProduct = currentVariant
      ? state.context.products.find(product =>
          product.variants.find(variant => variant.id === currentVariant.id),
        )
      : '';

    const bracketColourTag = currentProduct
      ? currentProduct.tags
          .find(tag => tag.includes('Bracket Colour'))
          ?.replace('Bracket Colour:', '')
      : '';

    const bracketColour =
      typeof bracketColourTag === 'string' && bracketColourTag !== ''
        ? bracketColourTag.trim()
        : 'Silver';

    const bracketColourHex = getRollerHexColour(bracketColour);

    const bottomRailColour = state.context.custom.bottomRailColour
      ? state.context.custom.bottomRailColour
      : 'Silver';

    const bottomRailColourHex = getRollerHexColour(bottomRailColour);

    return (
      <svg
        id="prefix__Layer_1"
        data-name="Layer 1"
        viewBox="0 0 554.21 269.49"
        {...props}
      >
        <defs>
          <pattern
            id="rollerFascia"
            patternUnits="userSpaceOnUse"
            width="100"
            height="100"
          >
            <image href={patternUrl} x="0" y="0" width="100" height="100" />
          </pattern>
        </defs>
        <defs>
          <linearGradient
            id="prefix__New_Gradient_Swatch_1"
            x1={-981.83}
            y1={-351.16}
            x2={-981.83}
            y2={-367.4}
            gradientTransform="translate(1258.81 411.92)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0.49} stopOpacity={0} />
            <stop offset={1} stopOpacity={0.3} />
          </linearGradient>
          <style>
            {'.prefix__cls-1{fill:#c9c1b4}.prefix__cls-3{fill:#1a1a1a}'}
          </style>
        </defs>
        <path
          className="prefix__cls-1"
          d="M554.21 0H0v44.63h10v217.01h534.1V44.63h10.11V0z"
        />
        <path
          className="prefix__cls-1"
          d="M10 44.63H.03L10 53.42v-8.79zM543.95 44.63v9.03l10.26-9.03h-10.26z"
        />
        <g opacity={0.3}>
          <path
            className="prefix__cls-3"
            d="M10 44.63H.03L10 53.42v-8.79zM543.95 44.63v9.03l10.26-9.03h-10.26z"
          />
        </g>
        <path
          fill="url(#prefix__New_Gradient_Swatch_1)"
          d="M543.95 60.76H10.27L10 44.51h533.95v16.25z"
        />
        <path fill="#939391" d="M10 261.62h533.95v7.87H10z" />
      </svg>
    );
  },
);
